import { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './config';

interface LanguageProviderProps {
  children: ReactNode;
}

export function LanguageProvider({ children }: LanguageProviderProps) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
